import { isLogisticsStageProgressDone } from "./logisticsRfqSentDeliveryUi.js";

/**
 * Logistics provider inbox: detect when delivery pipeline `grn_accept` is complete
 * (after POST accept-grn / GRN acceptance step).
 */

function parseStageProgress(dp) {
  if (!dp || typeof dp !== "object") return {};
  const raw = dp.stageProgress ?? dp.stage_progress;
  if (raw != null && typeof raw === "object" && !Array.isArray(raw)) return raw;
  if (typeof raw === "string" && raw.trim()) {
    try {
      const j = JSON.parse(raw);
      return j != null && typeof j === "object" && !Array.isArray(j) ? j : {};
    } catch {
      return {};
    }
  }
  return {};
}

/** @param {object|null|undefined} rfqRow Normalized row from RFQs received list */
export function isLogisticsGrnAcceptStageComplete(rfqRow) {
  const dp = rfqRow?.deliveryProcess;
  // No delivery_process row at all → buyer hasn't decided post-pickup yet.
  if (!dp) return false;
  const stages = Array.isArray(dp.selectedStages)
    ? dp.selectedStages.map((s) => String(s || "").trim()).filter(Boolean)
    : [];
  // Skip path: delivery_process row exists with no selected stages → buyer
  // explicitly chose "Skip & continue to invoice". There's nothing left to
  // wait for, so treat the GRN gate as satisfied and let the provider
  // generate the invoice immediately.
  if (stages.length === 0) return true;
  if (!stages.some((s) => s.toLowerCase() === "grn_accept")) return false;
  const prog = parseStageProgress(dp);
  const grnKey = stages.find((s) => s.toLowerCase() === "grn_accept");
  const v = grnKey ? prog[grnKey] : prog.grn_accept ?? prog.grnAccept;
  return isLogisticsStageProgressDone(v);
}
